import React, { memo } from "react";
import { useNotification } from "alpha-ui";
import styled from "styled-components";

const NotificationContainer = styled("div")(({ theme }) => ({
  position: "fixed",
  zIndex: 4000,
  top: 0,
  left: 0,
  width: "100%",
  display: "flex",
  boxSizing: "border-box",
  borderRadius: "0px 0px 14px 14px",
  overflow: "hidden",
  padding: "30px 24px 24px",
  cursor: "pointer",
  opacity: 0,
  transform: "translateY(-100%)",
  transition: "0.4s",
  "@media (max-width: 575px)": {
    padding: "20px 10px",
  },
  "&.success": {
    backgroundColor: "#4caf50",
    color: "white",
  },
  "&.error": {
    backgroundColor: "#f44336",
    color: "white",
  },
  "&.warning": {
    backgroundColor: "#ff9800",
    color: "white",
  },
  "&.visible": {
    opacity: 1,
    transform: "translateY(0%)",
  },
  p: {
    fontSize: "20px",
    lineHeight: "26px",
    color: "#f2f2f2",
    flexGrow: 1,
    whiteSpace: "pre-wrap",
    letterSpacing: "0.1px",
    margin: 0,
    "@media (max-width: 575px)": {
      fontSize: "15px",
    },
  },
  "> span": {
    marginLeft: "auto",
    cursor: "pointer",
    width: "24px",
    height: "24px",
    "> svg": {
      color: "#f2f2f2",
      fontSize: "22px",
    },
  },
}));

const NotificationPrompt = () => {
  // GET NOTIFICATION STATE FROM NOTIFICATION CONTEXT
  const { notification, visible, hideNotification } = useNotification();

  return (
    <NotificationContainer
      className={`notification ${notification?.type} ${
        visible ? "visible" : ""
      }`}
      role="alert"
      aria-live="assertive"
    >
      <p>{notification?.message}</p>
      <span onClick={hideNotification} aria-label="Close notification">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="feather feather-x"
        >
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </span>
    </NotificationContainer>
  );
};

export default memo(NotificationPrompt);
